// hooks/useRecaptchaScript.js
import { RECAPCHA_SCRIPT } from "@/constants/configurations";
import { useEffect, useState } from "react";

let loadPromise = null; 

export function useLoadRecaptchaScript(scriptSrc = RECAPCHA_SCRIPT, visible = true) {
  const [scriptLoaded, setScriptLoaded] = useState(
    typeof window !== "undefined" && !!window.grecaptcha
  );

  useEffect(() => {
    if (!visible) return;
    if (scriptLoaded) return;

    // Already loaded?
    if (window.grecaptcha) {
      setScriptLoaded(true);
      return;
    }

    // Already loading?
    if (loadPromise) {
      loadPromise.then(() => setScriptLoaded(true));
      return;
    }

    // Check if script tag exists
    const existing = document.querySelector("script[data-recaptcha-script]");
    if (existing) {
      loadPromise = new Promise((resolve) => {
        existing.addEventListener("load", () => {
          setScriptLoaded(true);
          resolve();
        }, { once: true });
      });
      return;
    }

    // Create script
    loadPromise = new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.defer = true;
      script.dataset.recaptchaScript = "true";
      script.onload = () => {
        setScriptLoaded(true);
        resolve();
      };
      document.head.appendChild(script);
    });
  }, [visible, scriptSrc, scriptLoaded]);

  return scriptLoaded;
}
